export default __webpack_public_path__ + "static/media/fashcard.79e370e1.png";